export default function ($) {
  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    addAnimation();
  }
  function addAnimation() {
    var $repeatedSentence = $('.repeated-sentence');
    var $repeatedSentenceContent = $repeatedSentence.children();

    $repeatedSentenceContent.clone().appendTo($repeatedSentence);

    var contentWidth = $repeatedSentenceContent.outerWidth(true);
    var animationDuration = contentWidth / 2;
    $repeatedSentence.css({
        'animation-name': 'scroll',
        'animation-duration': animationDuration + 's',
        'animation-timing-function': 'linear',
        'animation-iteration-count': 'infinite'
    });
  }
}
